<template>
    <div>
        <p v-if="error" class="text-danger">{{ errorMsg }}</p>
        <div class="d-flex justify-content-between align-items-end">
        <div class="">  <!-- Left Area -->
            <div class="" style="margin-bottom: 12px;">
                <b-link :href="rfxListUrl" class="text-decoration-none">
                    <!-- <b-icon icon="arrow-left-short"></b-icon> -->
                    &larr; 
                    Sourcing Home
                </b-link>
            </div>
            <div class="pb-1 d-flex align-items-center">
                <transition name="fade-fast" mode="out-in">
                    <h1 class="h2 mb-0" :key="localTitle">{{ localTitle }}</h1>
                </transition>
                <transition name="fade-fast" mode="out-in">
                    <b-badge
                        :key="localRfxStatusTitle"
                        class="text-uppercase ml-3 font-size-90" 
                        :variant="'soft-' + localRfxStatusVariant"
                    >
                        <b-icon icon="record-fill" :variant="localRfxStatusVariant" class="mr-1"></b-icon>
                        <span key="status">{{ localRfxStatusTitle }}</span>
                    </b-badge>
                </transition>
            </div>
            <div class="text-muted mt-1 mb-0 font-size-90 d-flex align-items-center">
                <div>
                    <b-icon icon="card-checklist" class="text-primary-lighter"></b-icon>
                    <span class="ml-2">{{ localRfxTypeDisplay }}</span>
                </div>
                <span v-if="localRfxCategoryName" class="mx-2">&middot;</span>
                <div v-if="localRfxCategoryName">
                    <b-icon icon="diagram3" class="text-primary-lighter"></b-icon>
                    <span class="ml-2">{{ localRfxCategoryName }}</span>
                </div>
                <span class="mx-2">&middot;</span>
                <div>
                    <b-icon icon="calendar2-date" class="text-primary-lighter"></b-icon>
                    <span v-if="localRfxCloseDate" class="ml-2">
                        {{ statusIsClosed ? 'Closed On: ' : 'Response Deadline: ' }} 
                        {{ localRfxCloseDate | dateFilter }}
                    </span>
                    <span v-else class="ml-2">Response Deadline: Not Set</span>
                </div>
            </div>
            <p class="text-muted d-none">Number:  {{ rfxId }}</p>
        </div>
        <div class="">  <!-- Right Area -->
            <b-button 
                variant="default" 
                :href="localRfxVendorUrl" 
                target="_blank"
                class="mb-0"
            >
                Supplier View
                <b-icon icon="box-arrow-up-right" class="ml-2"></b-icon>
            </b-button>
        </div>
    </div>
    </div>
</template>

<script>
import { suppliosApi } from '../js/api-service';
import { FormatDateHelper } from '../js/filters-helpers';
// make everything its own prop
// then have local data for all of them, set initial value to the prop
// then have a method that refreshes all the data from API and updates local data version
// OR... just pass object with updated data from other component to this one...

export default {
    name: 'RfxInternalHeader',
    components: {},
    props: {
        rfxId: {
            type: [String, Number],
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        rfxStatusValue: {
            type: String,
            required: true,
        },
        rfxStatusTitle: {
            type: String,
            required: true,
        },
        rfxStatusVariant: {  // this is rfx.state_dict.color_variant - no 'soft' prefix, just normal variants
            type: String,
            required: true,
        },
        rfxTypeDisplay: {
            type: String,
            required: true,
        },
        rfxCategoryName: {
            type: String,
            required: false,
        },
        rfxCloseDate: {
            type: [String, Date],
            required: false,
        },
        rfxListUrl: {
            type: String,
            default: '/sourcing/',
        },
        rfxVendorUrl: {
            type: String,
            required: true,
        },
        rfxSetupUrl: {
            type: String,
            required: true,
        },
        updatedData: {  // if you get new RFX data, pass the entire object here... this will get what it needs
            type: Object,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loading: false,
            didRefresh: false,  // set to true if/when you do a refresh
            localTitle: this.title,
            localRfxStatusValue: this.rfxStatusValue,
            localRfxStatusTitle: this.rfxStatusTitle,
            localRfxStatusVariant: this.rfxStatusVariant,  
            localRfxTypeDisplay: this.rfxTypeDisplay,
            localRfxCategoryName: this.rfxCategoryName,
            localRfxCloseDate: this.rfxCloseDate,
            localRfxListUrl: this.rfxListUrl,
            localRfxVendorUrl: this.rfxVendorUrl,
            localRfxSetupUrl: this.rfxSetupUrl,
        }
    },
    filters: {
        dateFilter: function(value) {
            return FormatDateHelper(value);
        },
    },
    computed: {
        statusIsClosed: function() {
            // making this computed here instead of passing in so you don't have to deal with booleans in django template using JS syntax
            let closedStatusList = ['review', 'closed', 'awarded', 'cancelled', 'archived'];
            return closedStatusList.includes(this.localRfxStatusValue);
        },
    },
    methods: {
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        // can call refreshData() from the parent using $refs
        updateData: function(newRfxData) {
            let respData = {...newRfxData};
            this.localTitle = respData.title;
            this.localRfxStatusValue = respData.state_dict.value;
            this.localRfxStatusTitle = respData.state_dict.title;
            this.localRfxStatusVariant = respData.state_dict.color_variant;
            this.localRfxTypeDisplay = respData.rfx_type_display;
            this.localRfxCategoryName = respData.sourcing_category_name;
            this.localRfxCloseDate = respData.close_date_to_show;
            // this.localRfxListUrl  ---- // this isn't in standard RFX retrieve response, and it won't be changing anyways, so just use prop value, provided by django template
            this.localRfxVendorUrl = respData.vendor_url;
            this.localRfxSetupUrl = respData.internal_setup_url;
            this.didRefresh = true;
        },
        // KEEP BOTH METHODS -- may need both of them, depending on situation
        refreshData: function() {
            console.log('Hello from inside refreshData in RfxInternalHeader');
            this.loading = true;
            return suppliosApi.rfx.retrieve(this.rfxId)
                .then(response => {
                    this.updateData(response.data);
                    return true;
                })
                .catch(error => {
                    this.handleError(error, 'Error while refreshing data');
                    return false;
                })
                .finally(successStatus => {
                    this.loading = false;
                    return successStatus;
                });
        }
    }
}
</script>

<style>

</style>